import { merge } from 'lodash';
import displaySettingsParams from './Tabs/Display/settings-params';

const settingsParams = merge(displaySettingsParams);

export default settingsParams;
